import React, { Component } from "react";
import PropTypes from "prop-types";
import FieldBase from "./FieldBase";

export default class SingleSelect extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    submitted: PropTypes.bool,
    value: PropTypes.string,
    options: PropTypes.array,
    name: PropTypes.string.isRequired,
  };

  static defaultProps = {
    value: "",
  };

  optionSelected = (e) => {
    const selectedValue = e.target.value;
    this.props.onChange(selectedValue);
  };

  render() {
    return (
      <FieldBase {...this.props}>
        {this.props.options.map((option) => (
          <div className="pad-half--ends" key={option.id}>
            <label className="radio">
              {option.label}
              <input
                checked={this.props.value === option.value}
                value={option.value}
                onChange={this.optionSelected}
                type="radio"
                name={this.props.name}
              />
              <span />
            </label>
          </div>
        ))}
      </FieldBase>
    );
  }
}
